import { ItemList } from '../../orm'

class AdminBulkEmailList extends ItemList {
    getEntityKey() {
        return "admin/bulk_email"
    }

    // Works out who the email would go to and records it. Nothing is sent yet - see
    // adminBulkEmailStartList below.
    prepareBulkEmail({editable_email, saved_search_customer, saved_search_subscription}) {
        return this.saveNewObject({editable_email: editable_email,
                                   saved_search_customer: saved_search_customer || null,
                                   saved_search_subscription: saved_search_subscription || null})
    }
}

export const adminBulkEmailList = new AdminBulkEmailList("admin_bulk_email__default")

class AdminBulkEmailStartList extends ItemList {
    getEntityKey() {
        return "admin/bulk_email/start"
    }

    // NB: sent as 'bulk_email' rather than 'id' - saveNewObject strips an 'id' key from the
    // payload, because it is normally there to identify an object being updated rather than a
    // value being posted.
    startBulkEmail(id) {
        return this.saveNewObject({bulk_email: id})
    }
}

export const adminBulkEmailStartList = new AdminBulkEmailStartList("admin_bulk_email_start__default")
